var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"desInner des01"},[_c('div',{staticClass:"desText",attrs:{"data-aos":"fade-right","data-aos-duration":"3000"}},[_c('div',{staticClass:"mainTitle"},[_c('p',[_vm._v("共享物流，共享價錢")])])]),_c('div',{staticClass:"desImg",attrs:{"data-aos":"fade-left","data-aos-duration":"2000"}},[_c('img',{attrs:{"loading":"lazy","alt":"","src":"img/share.jpg"}})])])
}]

export { render, staticRenderFns }